<template>
    <div class="flex-container my-4" :class="!idComponentePai ? 'card' : ''">
        <div class="flex gap-2">
            <p>
                {{ descricao }}
                <span v-if="respostaObrigatoria == true" class="text-xs text-vermelho-padrao">*</span>
            </p>
            <Status v-if="!idComponentePai || !resumoModulos" />
        </div>
        <div class="flex flex-row gap-6 flex-wrap">
            <label v-for="opcao in opcoesDisponiveis" :key="opcao.id" :for="opcao.id">
                <input :disabled="resumo" type="checkbox"
                    class="h-6 w-6 min-w-6 border-none border-preto-padrao cursor-pointer align-middle"
                    :name="`edt-${opcao.valor}`" :id="opcao.id" :value="opcao.valor"
                    :checked="opcaoUnica === opcao.valor" @click="opcaoSelecionada" />
                {{ opcao.valor }}
            </label>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import Status from '@/components/Status.vue';
import ComponenteOpcaoUnicaService from '@/services/componentes/ComponenteOpcaoUnicaService'
import ComponentesService from '@/services/ComponentesService'

export default defineComponent({
    name: 'OpcaoUnica',
    components: {
        Status
    },
    props: {
        ...PropsComponentesConstant.PROPS,
    },
    methods: {
        opcaoSelecionada(event) {
            if (this.resumo) return

            const opcaoSelecionada = event.target
            if (opcaoSelecionada.value === this.opcaoUnica) {
                document.getElementById(opcaoSelecionada.id).checked = true
                return
            }
            this.opcaoUnica = opcaoSelecionada.value
            const resposta = {
                descricao: this.descricao,
                resposta: this.opcaoUnica
            }
            ComponentesService.salvarRespostaEstadoComponente(this.modulo, this.etapaComponente, this.identificador, resposta, this.idComponentePai)
        }
    },
    setup(props) {
        return ComponenteOpcaoUnicaService.setup(props)
    }
});
</script>